import React from 'react';
import {NotificationManager} from 'react-notifications';
import verificarNif from "../../../utils/verifyNif";
import Swal from "sweetalert2";
import {Col, Container, Row} from "react-bootstrap";
import {Trans, withTranslation} from "react-i18next";

import Header from '../../../components/Header/Header';
import InputSelect from '../../../components/InputSelect/InputSelect';
import InputTextArea from '../../../components/InputTextArea/InputTextArea';
import CheckBox from '../../../components/CheckBox/CheckBox';
import Button from '../../../components/Button/Button';
import GiftIcon from '../../../assets/images/gift.svg';
import AvailabilityIcon from '../../../assets/images/availability.svg';
import BulletHeader from "../../../components/BulletHeader/BulletHeader";
import Input from "../../../components/Input";

import './styles.css';

class TermsAndConditions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      billing_name: '',
      nif: '',
      welcomepack_location: '',
      availability_1_day: '',
      availability_1_hour: '',
      availability_2_day: '',
      availability_2_hour: '',
      available_weekends: false,
      available_lunch_hours: false,
      available_mornings_and_afternoons: false,
      signed_responsability_term: false,
      accept_terms: false,
      accept_share_contact: false,
      accept_correct_info: false,
      accept_share_data: false,
      sending: false,
    };
  }


  render() {
    const { t } = this.props;
    let submit_text = t("registration_page.submit_registration");

    if (this.state.sending) {
      submit_text = t("common.please_wait");
    }

    return (
      <div>
        <Header headerBarTitle={t("registration_page.header")} showHeaderExtras showBackButton />

        <Container className={"desktop"}>
          <Row>
            <Col className={"pb-3"} xs={12} sm={12}>
              <BulletHeader text={t("registration_page.additional_data")}/>
              <p>{t("registration_page.additional_data_note")}</p>
            </Col>
          </Row>
          <Row className={"pb-1"}>
            <div className={"d-flex align-items-center icon-container"}>
              <img src={GiftIcon} style={{width:"100%"}} className={"img-fluid p-1"} alt={"gift icon"}/>
            </div>
            <div className={"d-flex align-items-center pl-0"}>
              <BulletHeader text={t("registration_page.welcome_pack")}/>
            </div>
          </Row>
          <Row className={"pb-4"}>
            <Col xs={12}>
              <InputSelect
                  labelClasses="label-style"
                  text={t("common.form.labels.welcome_kit_redeem_location")}
              >
                <select
                    onChange={this.handleChange}
                    defaultValue="DEFAULT"
                    name="welcomepack_location"
                    className="input-background"
                >
                  <option value="DEFAULT" disabled>{t("common.form.options.choose_an_option")}</option>
                  {this.props.formData.clubs.map((club, index) => {
                    return (
                        <option key={index} value={club.name}>
                          {club.name}
                        </option>
                    );
                  })}
                </select>
              </InputSelect>
            </Col>
          </Row>
          <Row className={"pb-1"}>
            <div className={"d-flex align-items-center icon-container"}>
              <img src={AvailabilityIcon} style={{width:"100%"}} className={"img-fluid  p-1"} alt={"schedule icon"}/>
            </div>
            <div className={"d-flex align-items-center pl-0"}>
              <BulletHeader text={t("registration_page.availabilities.title")}/>
            </div>
          </Row>
          <Row className={"pb-2"}>
            <Col xs={12} className={"pb-2"}>
              <p>{t("registration_page.availabilities.alert")}</p>
            </Col>

            <Col xs={12} className={"pb-2 pt-2"}>
              <h5>{`${t("registration_page.availabilities.availability")} 1`}</h5>
              <InputSelect labelClasses="label-style" text={t("common.form.labels.week_day")}>
                <select
                    onChange={this.handleChange}
                    defaultValue="DEFAULT"
                    name="availability_1_day"
                    className="input-background"
                >
                  <option value="DEFAULT" disabled>{t("common.form.options.choose_an_option")}</option>
                  <option value="Segunda-feira">{t("registration_page.availabilities.monday")}</option>
                  <option value="Terca-feira">{t("registration_page.availabilities.tuesday")}</option>
                  <option value="Quarta-feira">{t("registration_page.availabilities.wednesday")}</option>
                  <option value="Quinta-feira">{t("registration_page.availabilities.thursday")}</option>
                  <option value="Sexta-feira">{t("registration_page.availabilities.friday")}</option>
                </select>
              </InputSelect>
              <InputSelect labelClasses="label-style" text={t("common.form.labels.starting_hour")}>
                <select
                    onChange={this.handleChange}
                    defaultValue="DEFAULT"
                    name="availability_1_hour"
                    className="input-background"
                >
                  <option value="DEFAULT" disabled>{t("common.form.options.choose_an_option")}</option>
                  <option value="Fim_de_tarde">{t("registration_page.availabilities.late_afternoon")}</option>
                  <option value="Noite">{t("registration_page.availabilities.evening")}</option>
                  <option value="Fim_de_noite">{t("registration_page.availabilities.late_evening")}</option>
                </select>
              </InputSelect>
            </Col>
            <Col xs={12} className={"pb-2 pt-2"}>
              <h5>{`${t("registration_page.availabilities.availability")} 2`}</h5>
              <InputSelect labelClasses="label-style" text={t("common.form.labels.week_day")}>
                <select
                    onChange={this.handleChange}
                    defaultValue="DEFAULT"
                    name="availability_2_day"
                    className="input-background"
                >
                  <option value="DEFAULT" disabled>{t("common.form.options.choose_an_option")}</option>
                  <option value="Segunda-feira">{t("registration_page.availabilities.monday")}</option>
                  <option value="Terca-feira">{t("registration_page.availabilities.tuesday")}</option>
                  <option value="Quarta-feira">{t("registration_page.availabilities.wednesday")}</option>
                  <option value="Quinta-feira">{t("registration_page.availabilities.thursday")}</option>
                  <option value="Sexta-feira">{t("registration_page.availabilities.friday")}</option>
                </select>
              </InputSelect>
              <InputSelect labelClasses="label-style" text={t("common.form.labels.starting_hour")}>
                <select
                    onChange={this.handleChange}
                    defaultValue="DEFAULT"
                    name="availability_2_hour"
                    className="input-background"
                >
                  <option value="DEFAULT" disabled>{t("common.form.options.choose_an_option")}</option>
                  <option value="Fim_de_tarde">{t("registration_page.availabilities.late_afternoon")}</option>
                  <option value="Noite">{t("registration_page.availabilities.evening")}</option>
                  <option value="Fim_de_noite">{t("registration_page.availabilities.late_evening")}</option>
                </select>
              </InputSelect>
            </Col>
            <Col xs={12} className={"pb-2 pt-2"}>
              <CheckBox
                  handleChange={this.handleChange}
                  id="available_weekends"
                  checked={this.state.available_weekends}
                  name="available_weekends"
                  text={t("registration_page.availabilities.available_weekends")}
              />
              <CheckBox
                  handleChange={this.handleChange}
                  id="available_lunch_hours"
                  checked={this.state.available_lunch_hours}
                  name="available_lunch_hours"
                  text={t("registration_page.availabilities.available_lunch")}
              />
              <CheckBox
                  handleChange={this.handleChange}
                  id="available_mornings_afternoons"
                  checked={this.state.available_mornings_and_afternoons}
                  name="available_mornings_and_afternoons"
                  text={t("registration_page.availabilities.available_working_hours")}
              />
            </Col>
          </Row>

          <Row>
            <Col xs={12} className={"pb-2"}>
              <BulletHeader text={t("registration_page.disclaimer.title")}/>
              <p>{t("registration_page.disclaimer.alert")}</p>
            </Col>

            <Col xs={12}>
              <CheckBox
                  handleChange={this.handleChange}
                  id="responsability_term"
                  checked={this.state.signed_responsability_term}
                  name="signed_responsability_term"
                  text={t("registration_page.disclaimer.behaviour")}
              />
              <CheckBox
                  handleChange={this.handleChange}
                  id="accept_terms"
                  checked={this.state.accept_terms}
                  name="accept_terms"
              >
                {`${t("registration_page.disclaimer.accept_regulation_1")} `}
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={this.props.formData.terms_url}
                >
                  {`${t("registration_page.disclaimer.accept_regulation_2")} `}
                </a>
                {t("registration_page.disclaimer.accept_regulation_3")}
              </CheckBox>
              <CheckBox
                  handleChange={this.handleChange}
                  id="accept_share_contact"
                  checked={this.state.accept_share_contact}
                  name="accept_share_contact"
                  text={t("registration_page.disclaimer.share_contacts_league")}
              />
              <CheckBox
                  handleChange={this.handleChange}
                  id="accept_correct_info"
                  checked={this.state.accept_correct_info}
                  name="accept_correct_info"
                  text={t("registration_page.disclaimer.true_federation_info")}
              />
              <CheckBox
                  handleChange={this.handleChange}
                  id="accept_share_data"
                  checked={this.state.accept_share_data}
                  name="accept_share_data"
              >
                <Trans i18nKey="registration_page.disclaimer.share_info" components={{ strong: <strong /> }} />
              </CheckBox>
            </Col>
          </Row>

          <Row>
            <Col xs={12}>
              <hr/>
            </Col>
          </Row>

          <Row>
            <Col xs={12}>
              <InputTextArea
                  labelClasses={"font-weight-bold"}
                  handleChange={this.handleChange}
                  name="comments"
                  id="other_comments"
                  rows="3"
                  text={t("registration_page.additional_comments")}
              />
            </Col>
          </Row>

          {!this.props.formData.single_enrollment &&
          <Row>
            <Col xs={12} className={"pb-2"}>
              <BulletHeader text={t("registration_page.billing")}/>
              <Input handleChange={this.handleChange} name="billing_name" inputType="text" text={t("registration_page.billing_alert")} placeHolder={t("registration_page.billing_name")} inputTextValue={this.state.billing_name}/>
              <Input style={{marginTop: -20}} handleChange={this.handleChange} name="nif" inputType="text" placeHolder={t("registration_page.billing_nif")} inputTextValue={this.state.nif}/>
            </Col>
          </Row>
          }

          <Row>
            <Col xs={12} sm={{span: 6, offset: 3}} className={"pt-3"}>
              <Button onClick={() => this.submit({ info_and_conditions: this.state })} className={"mt-0 mb-4 w-100 btn btn-primary"} variant="secondary" disabled={this.state.sending}> {submit_text} </Button>
            </Col>
          </Row>

        </Container>
      </div>
    );
  }

  handleChange = event => {
    const value =
      event.target.type === 'checkbox'
        ? event.target.checked
        : event.target.value;

    this.setState({
      [event.target.name]: value,
    });
  };

  submit = data => {
    const { t } = this.props;
    let partnerName = this.props.formData.partner_registration ? ` - ${this.props.formData.partner_registration.name}`: "";

    if (this.verifyData()) {
      Swal.fire({
        allowOutsideClick: false,
        showCancelButton: true,
        titleText: t("registration_page.confirmation_popup.title"),
        html: `${t("registration_page.confirmation_popup.content")}<br><br><strong>${this.props.formData.name}<br>${this.props.formData.league_name}<br>${this.props.formData.category}<br>${this.props.formData.user_registration.name}${partnerName}</strong>`,
        confirmButtonText: t("common.yes"),
        cancelButtonText: t("registration_page.confirmation_popup.fix")
      }).then((res) => {
        if (res.dismiss === Swal.DismissReason.cancel){
          Swal.close();
        }else{
          if (!this.state.sending) {
            this.setState({ sending: true });
            this.props.onSubmit(data);
          }
        }
      });
    }
  };

  verifyData = () => {
    const { t } = this.props;
    let isAcceptable = true;

    if(this.state.nif !== '' && this.state.billing_name === ''){
      isAcceptable = false;
      NotificationManager.error(
         t("registration_page.errors.billing_name_mandatory"),
         t("common.error"),
         4000,
      );
      return isAcceptable;
    }

    if(this.state.billing_name !== '' && this.state.nif === ''){
      isAcceptable = false;
      NotificationManager.error(
         t("registration_page.errors.billing_nif_mandatory"),
         t("common.error"),
         4000,
      );
      return isAcceptable;
    }

    if(this.state.nif !== '' && !verificarNif(this.state.nif)){
      isAcceptable = false;
      NotificationManager.error(
         t("registration_page.errors.billing_nif_invalid"),
         t("common.error"),
         4000,
      );
      return isAcceptable;
    }

    if (this.state.welcomepack_location === '') {
      isAcceptable = false;
      NotificationManager.error(
         t("registration_page.errors.welcome_kit_mandatory"),
        t("common.error"),
        4000,
      );
      return isAcceptable;
    }

    if (this.state.availability_1_day === '') {
      isAcceptable = false;
      NotificationManager.error(
        t("registration_page.errors.availability_day_mandatory"),
        t("common.error"),
        4000,
      );
      return isAcceptable;
    }

    if (this.state.availability_1_hour === '') {
      isAcceptable = false;
      NotificationManager.error(
         t("registration_page.errors.availability_hour_mandatory"),
         t("common.error"),
        4000,
      );
      return isAcceptable;
    }

    if (this.state.availability_2_day === '') {
      isAcceptable = false;
      NotificationManager.error(
         t("registration_page.errors.availability_day_mandatory"),
         t("common.error"),
        4000,
      );
      return isAcceptable;
    }

    if (this.state.availability_2_hour === '') {
      isAcceptable = false;
      NotificationManager.error(
         t("registration_page.errors.availability_hour_mandatory"),
        t("common.error"),
        4000,
      );
      return isAcceptable;
    }

    if (this.state.availability_1_day === this.state.availability_2_day) {
      isAcceptable = false;
      NotificationManager.error(t("registration_page.errors.availability_same_days"), t("common.error"), 4000);
      return isAcceptable;
    }

    if (!this.state.signed_responsability_term) {
      isAcceptable = false;
      NotificationManager.error(
         t("registration_page.errors.disclaimer_accept_terms"),
         t("common.error"),
        4000,
      );
      return isAcceptable;
    }

    if (!this.state.accept_terms) {
      isAcceptable = false;
      NotificationManager.error(
         t("registration_page.errors.disclaimer_accept_regulation"),
         t("common.error"),
        4000,
      );
      return isAcceptable;
    }

    if (!this.state.accept_share_contact) {
      isAcceptable = false;
      NotificationManager.error(
         t("registration_page.errors.disclaimer_share_contacts"),
         t("common.error"),
        4000,
      );
      return isAcceptable;
    }

    if (!this.state.accept_correct_info) {
      isAcceptable = false;
      NotificationManager.error(
         t("registration_page.errors.disclaimer_truth_declaration"),
         t("common.error"),
        4000,
      );
      return isAcceptable;
    }

    return isAcceptable;
  };
}

export default withTranslation()(TermsAndConditions);
